<template>
  <div class="landing-page" :style="styles">
    <Dialog class="sign-in-dialog" v-model="showSignInDialog">
      <Auth 
        @close="showSignInDialog = false"
        @success="showSignInDialog = false"
      />
    </Dialog>
    <Dialog class="profile-dialog" v-model="showProfileDialog">
      <Dialog class="reset-dialog" v-model="showResetDialog">
         <div class="reset-dialog_wrapper">
          <button @click="showResetDialog = false" class="reset-dialog_close-button">
            <i class="material-icons">close</i>
          </button>
          <div class="reset-dialog_title">Изменить пароль</div>
          <form @submit.prevent="resetPassword">
            <FormField>
              <Input
                :invalid="$v.resetForm.currPassword.$error && !$v.resetForm.currPassword.required"
                v-model="$v.resetForm.currPassword.$model" placeholder="Текущий пароль" type="password" />
              <Error v-if="$v.resetForm.currPassword.$error && !$v.resetForm.currPassword.required">
                Поле обязательнное
              </Error>
            </FormField>
            <FormField>
              <Input
                :invalid="$v.resetForm.newPassword.$error && !$v.resetForm.newPassword.required"
                v-model="$v.resetForm.newPassword.$model" placeholder="Новый пароль" type="password" />
              <Error v-if="$v.resetForm.newPassword.$error && !$v.resetForm.newPassword.required">
                Поле обязательнное
              </Error>
            </FormField>
            <FormField>
              <Input
                :invalid="
                  ($v.resetForm.confirmNewPassword.$error && !$v.resetForm.confirmNewPassword.required) ||
                  ($v.resetForm.confirmNewPassword.required && $v.resetForm.confirmNewPassword.$dirty && !$v.resetForm.confirmNewPassword.sameAs)
                "
                v-model="$v.resetForm.confirmNewPassword.$model" placeholder="Повторите пароль" type="password" />
              <Error v-if="$v.resetForm.confirmNewPassword.$error && !$v.resetForm.confirmNewPassword.required">
                Поле обязательнное
              </Error>
              <Error v-if="$v.resetForm.confirmNewPassword.required && $v.resetForm.confirmNewPassword.$dirty && !$v.resetForm.confirmNewPassword.sameAs">
                Пароль не совпадает
              </Error>
            </FormField>
            <button type="submit" :disabled="$v.resetForm.$invalid"
              class="sign-in_button">
              Сменить
            </button>
          </form>
        </div>
      </Dialog>
      <div class="profile-dialog_wrapper">
        <div v-if="profileLoading" class="overlay-loading"></div>
        <button @click="showProfileDialog = false" class="profile-dialog_close-button">
          <i class="material-icons">close</i>
        </button>
        <div class="left-side">
          <Avatar
            :img="avatar"
            @remove="removeAvatar"
            @upload="selectAvatar"
          />
          <p>Вы можете загрузить файлы .jpg, .jpeg, .png, .svg, .gif</p>
          <div class="bottom">
            <button v-if="!isSocial" class="change-password-button" @click="showResetDialog = true">Сменить пароль</button>
            <button class="logout-button" @click="logout">Выйти</button>
            <router-link :to="{ name: 'clinic.list' }" class="link">Сменить клинику</router-link>
          </div>
        </div> 
        <div class="right-side">
          <div class="profile-dialog_title">Профиль</div>
          <form @submit.prevent="submit">
            <FormField>
              <Input v-model="profile.lastName" placeholder="Фамилия" />
            </FormField>
            <FormField>
              <Input v-model="profile.firstName" placeholder="Имя" />
            </FormField>
            <FormField>
              <Input v-model="profile.middleName" placeholder="Отчество" />
            </FormField>
            <FormField>
              <Input v-model="profile.phone" placeholder="Телефон" />
            </FormField>
            <RadioGroup class="sex-group" v-model="profile.gender" :options="genderOptions" />
            <DatePicker v-model="profile.birthDay" :popover="{ visibility: 'focus' }">
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="custom-field"
                  placeholder="День рождения"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </DatePicker>
            <div class="bottom">
              <button
                class="landing-button outline-landing-button"
                type="button"
                @click="reset">
                Отмена
              </button>
              <button class="landing-button submit-button" type="submit">Сохранить</button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
    <Dialog class="appointment-list-dialog" v-model="showAppointmentListDialog">
      <Dialog class="cancel-appointment-dialog" v-model="showCancelAppointmentDialog">
        <div class="cancel-appointment-dialog_wrapper">
          <div class="cancel-appointment-dialog_title">Вы уверены что хотите<br>отменить запись?</div>
          <div v-if="selectedCancelAppointment">
            <div class="appointment-item">
              <div class="top">
                <div class="avatar">
                  <div v-if="selectedCancelAppointment.avatar"
                    :style="{ backgroundImage: `url(${selectedCancelAppointment.avatar}` }">
                  </div>
                  <img v-else class="placeholder" src="@/assets/user.svg" alt="Аватар">
                </div>
                <div class="right-side">
                  <div class="name">{{ selectedCancelAppointment.fullName }}</div>
                  <div class="department">{{ selectedCancelAppointment.subTitle }}</div>
                  <div class="appointment-time">
                    <div class="date">
                      <i class="material-icons">calendar_today</i>
                      <span>{{ selectedCancelAppointment.date }}</span>
                    </div>
                    <div class="time">
                      <i class="material-icons">access_time</i>
                      <span>{{ selectedCancelAppointment.time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <button class="refuse-button" @click="showCancelAppointmentDialog = false">Нет</button>
            <button class="accept-button" @click="cancelAppointment()">Да</button>
          </div>   
        </div>
      </Dialog>
      <div class="appointment-list-dialog_wrapper">
        <div class="appointment-list-dialog_title">Записи</div>
        <button @click="showAppointmentListDialog = false" class="appointment-list-dialog_close-button">
          <i class="material-icons">close</i>
        </button>
        <div class="appointment-list-wrapper">
          <Tabs v-model="tab" :tabs="[ 'Предстоящие', 'Завершенные', 'Отмененые' ]" />
          <div class="appointment-list" :class="{ center: !appointmentList.length && !appointmentListLoading }">
            <template v-if="!appointmentListLoading">
              <div v-for="appointment in appointmentList" :key="appointment.id" class="appointment-item">
                <div class="top">
                  <div class="avatar">
                    <div v-if="appointment.avatar"
                      :style="{ backgroundImage: `url(${appointment.avatar}` }">
                    </div>
                    <img v-else class="placeholder" src="@/assets/user.svg" alt="Аватар">
                  </div>
                  <div class="right-side">
                    <div class="name">{{ appointment.fullName }}</div>
                    <div class="department">{{ appointment.subTitle }}</div>
                    <div class="type">
                      <i class="material-icons">{{ appointment.type === 0 ? 'event_seat' : 'voice_chat' }}</i>
                      <span>{{ appointment.type === 1 ? 'Видео-консультация' : 'Частный прием' }}</span>
                    </div>
                    <div class="appointment-time">
                      <div class="date">
                        <i class="material-icons">calendar_today</i>
                        <span>{{ appointment.date }}</span>
                      </div>
                      <div class="time">
                        <i class="material-icons">access_time</i>
                        <span>{{ appointment.time }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="'Предстоящие' === tab">
                  <button @click="selectCancelAppointment(appointment)">Отменить</button>
                  <button
                    @click="toVideoCall(appointment.conversation)"
                    v-if="appointment.type === 1 && appointment.timestamp < delay">
                    Видеоконсультация
                  </button>
                </div> 
              </div>
            </template>
            <div v-if="appointmentListLoading">
              <div class="appointment-item appointment-loading">
                <div class="top">
                  <div class="avatar"></div>
                  <div class="right-side">
                    <div class="name"></div>
                    <div class="department"></div>
                    <div class="appointment-time">
                      <div class="date"></div>
                      <div class="time"></div>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="'Предстоящие' === tab">
                  <div class="button"></div>
                </div> 
              </div>
              <div class="appointment-item appointment-loading">
                <div class="top">
                  <div class="avatar"></div>
                  <div class="right-side">
                    <div class="name"></div>
                    <div class="department"></div>
                    <div class="appointment-time">
                      <div class="date"></div>
                      <div class="time"></div>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="'Предстоящие' === tab">
                  <div class="button"></div>
                </div> 
              </div>
            </div>
            <div class="appointment-list-loading" v-if="!appointmentList.length && !appointmentListLoading">
              <img src="@/assets/user-list.svg" alt="">
              <span>Список записей пуст...</span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <section class="main">
      <header :class="classes">
        <div class="logotype"><img :src="organization.logo" /></div>
        <div class="auth-loading" v-if="loginLoading">Авторизация...</div>  
        <nav v-else>
          <button class="video-conv-button" v-if="activeAppointment && activeAppointment.timestamp < delay">
            <span class="blob"></span>
            <span class="text" @click="toVideoCall(activeAppointment.conversation)">Видеоконсультация</span>
          </button>
          <router-link v-if="isAdmin" :to="{ name: 'personal-area.clinic' }">
            Настройки клиники
          </router-link>
          <button v-if="isAuth" @click="openAppointmentDialog">Записи</button>
          <button v-if="isAuth" @click="loadProfile">Профиль</button>
          <button v-if="!isAuth" @click="showSignInDialog = true">Вход</button>
        </nav>
      </header>
      <div class="content">
        <h1>{{ organization.title }}</h1>
        <p>{{ description }}</p>
      </div>
    </section>
    <section>
      <div class="services">
        <div class="service" v-for="service in services" :key="service.id">
          <div class="icon">
            <img :src="service.icon" :alt="service.name">
          </div>
          <div class="name">{{ service.name }}</div>
        </div>
      </div>
    </section>
    <section class="appointment-doctor">
      <h3>Запишитесь на приём к врачу</h3>
      <Appointment @appointment="openAppointmentDialog" />
    </section>
    <section class="map-section">
      <yandex-map class="map"
        :coords="center"
        :controls="[]"
        :zoom="16">
        <ymap-marker 
          :coords="coords"
          :icon="markerIcon"
          marker-id="123" 
          hint-content="Мы здесь!" 
        />
      </yandex-map>
      <div class="address-box">
        <div class="box" v-if="organization.address">
          <div class="label">Адрес</div>
          <div class="value">{{ organization.address }}</div>
        </div>
        <div class="box" v-if="organization.worktime">
          <div class="label">Время работы</div>
          <div class="value">{{ organization.worktime }}</div>
        </div>
        <div class="box" v-if="organization.phones">
          <div class="label">Телефон</div>
          <div class="value">{{ organization.phones }}</div>
        </div>
      </div>
    </section>
    <section>
      <footer>
        <div class="developer">2021 RADIUS-ETL</div>
        <div class="social-list">
          <a v-if="organization.front.fb" :href="organization.front.fb" title="Facebook">
            <FacebookSocialIcon />
          </a>
          <a v-if="organization.front.ig" :href="organization.front.ig" title="Instagram">
            <InstagramSocialIcon />
          </a>
          <a v-if="organization.front.ok" :href="organization.front.ok" title="Одноклассники">
            <OdnoklassnikiSocialIcon />
          </a>
          <a v-if="organization.front.tg" :href="organization.front.tg" title="Telegram">
            <TelegramSocialIcon />
          </a>
          <a v-if="organization.front.tw" :href="organization.front.tw" title="Twitter">
            <TwitterSocialIcon />
          </a>
          <a v-if="organization.front.vk" :href="organization.front.vk" title="Вконтакте">
            <VkSocialIcon />
          </a>
          <a v-if="organization.front.yt" :href="organization.front.yt" title="YouTube">
            <YoutubeSocialIcon />
          </a>
        </div> 
      </footer>
    </section>
  </div>
</template>

<script>
import moment from 'moment';

import Dialog from '@app/components/uikit/Dialog';
import Input from '@app/components/uikit/Input';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';

import ElectrocardiogramSvg from '@app/assets/electrocardiogram.svg';
import ResonanceSvg from '@app/assets/resonance.svg';
import SonographySvg from '@app/assets/sonography.svg';
import XRaySvg from '@app/assets/x-ray.svg';
import store from '@app/store';

import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import MedicalIcon from '@app/assets/medical-pin.svg';

import { http, authApi, laravelHttp, refBookHttp, receptionHttp,
  doctorApi, uploadImageApi, patientApi, timetableApi } from '@app/services';
import Appointment from './appointment';
import RadioGroup from './components/radio-group';
import Tabs from './components/tabs';

import DatePicker from 'v-calendar/lib/components/date-picker.umd';

import FacebookSocialIcon from '@app/assets/social-icons/facebook.svg?inline';
import InstagramSocialIcon from '@app/assets/social-icons/instagram.svg?inline';
import OdnoklassnikiSocialIcon from '@app/assets/social-icons/odnoklassniki.svg?inline';
import TelegramSocialIcon from '@app/assets/social-icons/telegram.svg?inline';
import TwitterSocialIcon from '@app/assets/social-icons/twitter.svg?inline';
import VkSocialIcon from '@app/assets/social-icons/vk.svg?inline';
import YoutubeSocialIcon from '@app/assets/social-icons/youtube.svg?inline';

import Avatar from './components/avatar';
import { required, sameAs } from 'vuelidate/lib/validators';
import parse from 'parse-color';

import Auth from './dialogs/auth';

const host = `${window.location.origin}`;

export default {
  components: {
    Auth,
    Appointment, yandexMap, ymapMarker, Dialog, Input, FormField,
    FacebookSocialIcon, InstagramSocialIcon,
    OdnoklassnikiSocialIcon, TelegramSocialIcon, TwitterSocialIcon, VkSocialIcon, YoutubeSocialIcon,
    RadioGroup, DatePicker, Avatar, Tabs, Error,
  },
  data: () => ({
    activeAppointment: null,
    loginLoading: false,
    regUsernameError: false,
    isSignIn: true,
    username: '',
    password: '',
    resetForm: {
      currPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    regForm: {
      firstName: '',
      lastName: '',
      username: '',
      password: '',
      confirmPassword: '',
    },
    tab: 'Предстоящие',
    genderOptions: [
      { value: 'male', label: 'Мужской' },
      { value: 'female', label: 'Женский' }
    ],
    selectedCancelAppointment: null,
    appointmentList: [],
    appointmentListLoading: false,
    profileLoading: false,
    avatarLoading: false,
    date: null,
    okLink: `https://connect.ok.ru/oauth/authorize?client_id=512000667489&scope=VALUABLE_ACCESS&response_type=token&redirect_uri=${host}?redirect_url=${window.location.pathname}`,
    vkLink: `https://oauth.vk.com/authorize?client_id=7606335&display=page&redirect_uri=${host + window.location.pathname}&scope=email&response_type=code&v=5.124`,
    instLink: `https://api.instagram.com/oauth/authorize?client_id=824347501663095&redirect_uri=${host}/&scope=user_profile,user_media&response_type=code&state=${window.location.pathname}`,
    yandexLink: `https://oauth.yandex.ru/authorize?response_type=code&client_id=9aa642bb862c4bfb922d04096c3a17ae&redirect_uri=${host}?redirect_url=${window.location.pathname}`,
    googleSignInParams: {
      client_id: '895949417832-d1o922c3thm4mhtjqq8dhk54d99jdoq6.apps.googleusercontent.com'
    },
    fbSignInParams: {
      scope: 'email,user_likes',
      return_scopes: true
    },
    showResetDialog: false,
    showAppointmentDialog: false,
    showCancelAppointmentDialog: false,
    showSignInDialog: false,
    showProfileDialog: false,
    showAppointmentListDialog: false,
    organization: null,
    // uuid: uuid,
    services: [
      {
        id: 0,
        name: 'КТ',
        icon: ResonanceSvg
      },
      {
        id: 1,
        name: 'УЗИ',
        icon: SonographySvg
      },
      {
        id: 2,
        name: 'Кардиография',
        icon: ElectrocardiogramSvg
      },
      {
        id: 3,
        name: 'Флюрография',
        icon: XRaySvg
      }
    ],
    markerIcon: {
      layout: 'default#imageWithContent',
      imageHref: MedicalIcon,
      imageSize: [64, 64],
      imageOffset: [-32, -64],
    },
    center: [
      59.937500,
      30.308611,
    ],
    coords: [
      59.937500,
      30.308611,
    ],
    classes: { filled: false },
    profile: {
      firstName: null,
      lastName: null,
      middleName: null,
      gender: null,
      phone: null,
      birthDay: null
    },
    lighten: false,
    now: null
  }),
  async created() {
    this.organization = { ...this.$store.state.clinic.organization.form };
    this.services = !!this.organization?.front?.services ? this.organization.front.services : this.services;
    if (this.organization && this.organization.front && this.organization.front.coords) {
      this.center = this.organization.front.coords;
      this.coords = this.organization.front.coords;
    }
    this.loadDoctors();
    window.addEventListener('scroll', this.handleScroll);

    const urlParams = new URLSearchParams(this.$route.hash);
    const accessToken = this.$route.query.code ? this.$route.query.code : urlParams.get('#access_token');

    const secterKey = urlParams.get('session_secret_key');

    if (!this.isAuth && accessToken) {
      this.loginLoading = true;
      try {
        if (secterKey) {
          await this.login('odnoklassniki-oauth2', accessToken);
        } else {
          const isInstagramOAuth = this.$route.hash === '#_';
          const isYandexOAuth = accessToken.length < 8 && /^-?\d+$/.test(accessToken);
          if (isInstagramOAuth) {
            await this.login('instagram', accessToken);
          } else if (isYandexOAuth) {
            await this.login('yandex-oauth2', accessToken);
          } else {
            await this.login('vk-oauth2', accessToken);
          }
        }
      } catch (err) {
        console.log(err);
      }
      this.loginLoading = false;
    }
    this.tab = 'Предстоящие';
    await this.loadRecords();
    setTimeout(this.tickNow, 1);
  },
  computed: {
    roles() {
      const { resources } = this.$store.state.permission;
      const uuid = this.$store.state.clinic.id;
      return (!resources ||
        typeof resources.organization === 'undefined' ||
        typeof resources.organization[uuid] === 'undefined') ? []
        : resources.organization[uuid].roles;
    },
    isAdmin() {
      return this.roles.indexOf('orgadmin') > -1;
    },
    delay() {
      return this.now + 3 * 60 * 60 * 1000;
    },
    description() {
      return this.organization.info.split(' ').reduce((acc, curr) => {
        return acc.length > 255 ? acc : `${acc} ${curr}`;
      }, '');
    },
    styles() {
      const [ red, green, blue ] = (this.organization.front && this.organization.front.theme) ?
        parse(this.organization.front.theme.background).rgb : [ 140, 190, 255 ];
      const isLighten = this.isLighten([ red, green, blue ]);
      const alpha = isLighten ? '0.7' : '0.4';
      return {
        '--theme-header-background': !isLighten ?
          `rgba(${red}, ${green}, ${blue}, ${alpha})` : 'transparent',
        '--theme-background-color': `rgba(${red}, ${green}, ${blue}, ${alpha})`,
        '--theme-text-color': isLighten ? '#ffffff' : '#222222',
        '--theme-service-color': `rgba(${red}, ${green}, ${blue}, 0.15)`,
        '--theme-service-hover-color': `rgba(${red}, ${green}, ${blue}, 0.09)`,
        '--theme-service-map-color': `rgba(${red}, ${green}, ${blue}, 0.9)`,
      };
    },
    avatar() {
      return this.$store.state.clinic.personal?.avatar;
    },
    isAuth() {
      return this.$store.state.auth.is_auth;
    },
    isSocial() {
      return this.$store.state.permission.isSocial;
    },
  },
  watch: {
    showResetDialog(value) {
      if (value) {
        return;
      }
      this.resetForm = {
        currPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      };
      this.$v.resetForm.$reset();
    },
    'regForm.username': function() { this.regUsernameError = false; },
    tab(value) {
      this.loadAppointmentList(value);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  validations: {
    resetForm: {
      currPassword: { required },
      newPassword: { required },
      confirmNewPassword: {
        required,
        sameAs: sameAs(function() {
          return this.resetForm.newPassword;
        }),
      },
    },
    username: { required },
    password: { required },
    regForm: {
      firstName: { required },
      lastName: { required },
      username: { required },
      password: { required },
      confirmPassword: {
        required,
        sameAs: sameAs(function() {
          return this.regForm.password;
        }),
      },
    }
  },
  methods: {
    toVideoCall(id) {
      this.$router.push({ name: 'video.appointment', params: { id }});
    },
    isLighten([r, g, b]) {
      return (r * 0.299 + g * 0.587 + b * 0.114) <= 186;
    },
    tickNow() {
      this.now = Date.now();
      setTimeout(this.tickNow, 5000);
    },
    async openAppointmentDialog() {
      this.tab = 'Предстоящие';
      await this.loadRecords();
      this.showAppointmentListDialog = true;
    },
    async resetPassword() {
      const params = {
        current_password: this.resetForm.currPassword,
        new_password: this.resetForm.newPassword,
        new_password_confirmation: this.resetForm.confirmNewPassword,
      };
      await authApi.reset(params);
      this.showResetDialog = false;
    },
    async selectCancelAppointment(appointment) {
      this.selectedCancelAppointment = appointment;
      this.showCancelAppointmentDialog = true;
    },
    async cancelAppointment() {
      try {
        const { id } = this.selectedCancelAppointment;
        await timetableApi.update(id, { patient: null, is_reserve: false });
        await this.loadFutureAppointment();
      } catch (error) {
        this.$bvToast.toast(error, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      }
      this.showCancelAppointmentDialog = false;
    },
    async loadAppointmentList(value) {
      this.appointmentListLoading = true;
      if (value === 'Предстоящие') {
        await this.loadFutureAppointment();
      } else if (value === 'Завершенные') {
        await this.loadAppointment();
      } else {
        await this.loadCancelAppointment();
      }
      await new Promise(resolve => setTimeout(resolve, 300));
      this.appointmentListLoading = false;
    },

    async loadRecords() {
      await this.loadAppointmentList(this.tab);
    },
    appoinmentFormatted({ id, doctor, start_time, type, end_time, conversation }) {
      const { avatar, last_name, first_name, middle_name } = doctor.employee;
      const { title: department } = doctor.department;
      const { title: specialty } = doctor.specialty;
      const subTitle = `${specialty} / ${department}`;
      const fullName = `${last_name} ${first_name} ${middle_name}`;
      const date = moment(start_time).format('DD.MM.YYYY');
      const time = moment(start_time).format('HH:mm');
      const timestamp = new Date(start_time).getTime();
      return { id, avatar, fullName, subTitle, date, time, timestamp, type, conversation };
    },
    async loadAppointment() {
      try {
        const params = { with_reception: 1 };
        const { items } = await patientApi.getSlots(params, false);
        this.appointmentList = items.map(this.appoinmentFormatted);
      } catch(error) {
        toastr.error(error);
      }
    },
    async loadFutureAppointment() {
      try {
        const params = { start_time: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss') };
        const { items } = await patientApi.getSlots(params, false);
        this.appointmentList = items.map(this.appoinmentFormatted);
        // active appointment
        const onlineApps = this.appointmentList
          .filter(a => a.type === 1)
          .sort((a, b) => a.timestamp - b.timestamp);
        this.activeAppointment = onlineApps.length ? onlineApps[0] : null;
      } catch(error) {
        toastr.error(error);
      }
    },
    async loadCancelAppointment() {
      try {
        const params = { cancel_reception: 1 };
        const { items } = await patientApi.getSlots(params);
        this.appointmentList = items.map(this.appoinmentFormatted);
      } catch(error) {
        toastr.error(error);
      }
    },
    async logout() {
      // this.logoutLoading = true;
      try {
        this.$store.dispatch('auth/resetAuthUserDetail');
        http.removeToken();
        laravelHttp.removeToken();
        this.$store.commit('permission/removeResources');
        this.$store.commit('clinic/setRoles', []);
        this.showProfileDialog = false;
      } catch (e) {
        console.error(e);
      }
      // this.logoutLoading = false;
    },
    reset() {
      this.profile = { ...this.$store.state.clinic.personal };
    },
    async submitSignUp() {
      const body = {
        username: this.regForm.username,
        password: this.regForm.password,
        first_name: this.regForm.firstName,
        last_name: this.regForm.lastName,
      };
      const httpClient = axios.create();
      delete httpClient.defaults.headers.common['Authorization'];
      try {
        await httpClient.post('/api/auth/register/', body);
        const token = await this.loginForm(body.username, body.password);
        await this.setToken(token);
        this.showSignInDialog = false;
        this.isSignIn = true;
        this.regUsernameError = false;
        this.$v.$reset;
      } catch (error) {
        this.regUsernameError = !error?.data?.errors?.username[0];
      }
    },
    async submitLogin() {
      await this.login();
    },
    async submit() {
      this.profileLoading = true;
      const birthDay = this.profile.birthDay ? moment(this.profile.birthDay).format('YYYY-MM-DD') : null;
      const profile = { ...this.profile, birthDay };
      await this.$store.dispatch('clinic/savePersonal', profile);
      await this.$store.dispatch('permission/loadPermissions');
      this.profileLoading = false;
    },
    async loadProfile() {
      await this.$store.dispatch('clinic/loadPersonal');
      this.profile = { ...this.$store.state.clinic.personal };
      this.showProfileDialog = true;
    },
    async selectAvatar(file) {
      const avatar = await this.uploadFile(file);
      this.profile.avatar = avatar;
      await this.$store.dispatch('clinic/saveAvatar', avatar);
      await this.$store.dispatch('permission/loadPermissions');
    },
    async removeAvatar() {
      this.profile.avatar = null;
      this.$store.state.clinic.personal.avatar = null;
      await this.$store.dispatch('clinic/saveAvatar', null);
      await this.$store.dispatch('permission/loadPermissions');
    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      return await uploadImageApi.upload(formData);
    },
    async loginForm(username, password) {
      const body = { 
        username, 
        password,
        grant_type: 'password',
        client_id: 2,
        client_secret: 'WJC4eSpLDGtdtcyh0NfuwCNk6PtCZH1U9vNh0Hu7'
      };
      try {
        const { data } = await axios.post('/oauth/token/', body);
        return data.access_token;
      } catch (error) {
        throw error;
      }
    },
    async loginOAuth(social, token) {
      const body = { 
        backend: social,
        grant_type: 'convert_token',
        client_id: 2,
        client_secret: 'WJC4eSpLDGtdtcyh0NfuwCNk6PtCZH1U9vNh0Hu7',
        token,
        redirect_uri: social === 'instagram' ? window.location.origin + '/' : `${window.location.origin + window.location.pathname}`,
      };
      const headers = { Authorization: 'NoAuth' };
      const { data } = await axios.post('/convert-token/', body, { headers });
      return data.access_token;
    },
    async login(social, oauthToken) {
      const token = !social ?
        await this.loginForm(this.username, this.password) :
        await this.loginOAuth(social, oauthToken);
      this.showSignInDialog = false;
      this.username = '';
      this.password = '';
      await this.setToken(token);
    },
    async setToken(token) {
      localStorage.setItem('auth_token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      http.setToken(token);
      laravelHttp.setToken(token);
      refBookHttp.setToken(token);
      receptionHttp.setToken(token);
      await helper.check();
      await this.$store.dispatch('permission/loadPermissions');
      await this.$store.dispatch('auth/setAuthStatus');
      await this.$store.dispatch('auth/setLastActivity');
    },
    async onSignInGoogleSuccess(googleUser) {
      const accessToken = Object.entries(googleUser).reduce((acc, [ key, value ]) => {
        if (!acc && value.access_token) {
          return value.access_token;
        }
        return acc;
      }, null);
      await this.login('google-oauth2', accessToken);
    },
    async onSignInFacebookSuccess(response) {
      await FB.api('/me');
      await this.login('facebook', response.authResponse.accessToken);
    },
    log(event) {
      console.log(event);
    },
    handleScroll(event) {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.classes.filled = currentScrollPosition > 50;
    },
    async loadDoctors() {
      this.doctorLoading = true;
      const { items } = await doctorApi.getAll();
      this.doctors = items;
      this.doctorLoading = false;
    }
  },
  async beforeRouteEnter(to, from, next) {
    // http.setApiKey(uuid);
    await store.dispatch('clinic/preload', 'personal-area.main');
    next();
  },
  async beforeRouteUpdate(to, from, next) {
    // http.setApiKey(uuid);
    await store.dispatch('clinic/preload', 'personal-area.main');
    next();
  }
};
</script>

<style scoped>
.video-conv-button {
  display: flex;
  align-items: center;
}
span.blob {
  display: block;
	background: rgba(255, 82, 82, 1);
	border-radius: 50%;
	box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
	margin-right: 10px;
	height: 10px;
	width: 10px;
	transform: scale(1);
	animation: pulse-red 1500ms infinite;
}
.video-conv-button:hover .text {
  color: rgba(255, 82, 82, 1);
}
@keyframes pulse-red {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
	}
	
	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
	}
	
	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
	}
}
.landing-page button {
  outline: 0;
}
h3 {
  margin-bottom: 2rem;
  color: #424242;
  padding: 0 24px;
  width: 100%;
  text-align: center;
}
section.main {
  display: flex;
  flex-direction: column;
  background-image: url('~@/assets/clinic-bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 67px;
  height: 28rem;
  position: relative;
}
section.main:before {
  content: ' ';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,.5);
  /* background-color: var(--theme-background-color); */
}
section.main .content {
  position: relative;
  padding: 0 3rem;
  color: #fff;
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
section.main .content h1 {
  font-size: 3rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  padding: 0;
  margin: 0;
  line-height: 1;
  margin-bottom: 1rem;
}
section.main .content p {
  font-size: 1.5rem;
  font-weight: 300;
  margin: 0;
}
header {
  position: fixed;
  top: 0; left: 0; right: 0;
  display: flex;
  color: var(--theme-text-color);
  justify-content: space-between;
  padding: 0 1.2rem;
  z-index: 3;
  height: 3.5rem;
  transition: background-color 200ms ease-in;
  background-color: var(--theme-header-background);
}
header.filled {
  /* backdrop-filter: saturate(180%) blur(20px); */
  background-color: var(--theme-background-color);
}
header .logotype {
  text-transform: uppercase;
  display: flex;
  font-weight: 800;
  font-size: 1rem;
  align-items: center;
}
header .logotype img {
  max-width: 120px;
  max-height: 42px;
  height: auto;
  display: block;
  margin-right: 1rem;
}
.auth-loading,
header nav {
  display: flex;
  align-items: center;
}
header nav a,
header nav button {
  color: var(--theme-text-color);
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1;
  margin-left: 1rem;
  padding: 0;
  text-decoration: none;
  transition: color 200ms ease;
}
header nav a:hover,
header nav button:hover {
  color: var(--theme-text-color);
}
header nav button {
  background-color: transparent;
  border: 0;
  outline: 0;
}
.services {
  /* background-color: rgb(240, 252, 255); */
  background-color: var(--theme-service-color);
  display: flex;
  justify-content: center;
  padding: 2rem 0;
  flex-wrap: wrap;
}
.services .service {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 1px 10px 2px rgba(0,0,0,.1);
  margin-left: 1rem;
  min-width: 12rem;
  height: 6rem;
  cursor: pointer;
  transition: all 300ms ease;
  margin: 0.5rem;
}
.services .service:hover {
  background-color: var(--theme-service-hover-color);
  transform: scale(1.05);
}
.services .service img {
  width: 60px;
  padding: 1rem;
}
.services .service .name {
  font-weight: 300;
  color: #424242;
}
.appointment-doctor {
  box-shadow: inset 0 8px 20px 3px rgba(0,0,0,.033),
    inset 0 -8px 20px 3px rgba(0,0,0,.033);
  background-color: #fafafa;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.appointment-landing {
  width: 600px;
}
.map-section {
  min-height: 300px;
  position: relative;
  display: flex;
  align-items: center;
}
.map {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 40%;
  right: 0;
  z-index: 2;
}
.address-box {
  width: 40%;
  /* background-color: rgba(110, 180, 197, 0.95); */
  background-color: var(--theme-service-map-color);
  min-height: 300px;
}
footer {
  background-color: rgb(114, 117, 117);
  color: #fff;
  padding: 1rem 2rem;
  display: flex;
}
footer .social-list {
  display: flex;
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: flex-end;
}
footer .social-list a {
  display: block;
  margin: 0.5rem;
}
footer svg {
  width: 22px;
  height: 22px;
}
footer .developer {
  display: flex;
  align-items: center;
  white-space: pre;
}
.address-box {
  display: flex;
  flex-direction: column;
  padding: 2rem;
}
.address-box .box {
  color: var(--theme-text-color);
  display: flex;
  margin-bottom: 24px;
}
.address-box .box .label {
  flex: 0 0 180px;
  font-weight: 600;
  text-transform: uppercase;
}
.address-box .box .value {
  flex: auto;
  white-space: pre-wrap;
  font-weight: 300;
}
.sign-in-dialog_wrapper {
  padding: 0 2rem;
  position: relative;
}
.sign-in-dialog_title {
  width: 300px;
  font-weight: 600;
  text-align: center;
  padding: 1rem 0;
  font-size: 1.5rem;
  color: #424242;
}
.social-auth {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
}
form {
  padding: 1rem;
}
.fb-signin-button {
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.yandex-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.yandex-link svg {
  height: 20px;
  width: 40px;
  margin-right: 2px;
}
.social-link {
  display: block;
  width: 40px;
  border-radius: 50%;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.social-link svg {
  width: 40px;
}
.odnoklassniki-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff9801;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.odnoklassniki-link svg {
  color: #fff;
  width: 20px;
}
.blank-link {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  width: 40px;
  border-radius: 50%;
  height: 40px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, .1);
}
.blank-link svg {
  width: 20px;
}
.diviner {
  position: relative;
  height: 1px;
  width: 100%;
  border-top: 1px solid rgb(219, 219, 219);
  margin: 1rem 0;
}
.diviner span {
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  top: -10px;
  margin: auto;
  width: 50px;
  line-height: 1;
  text-align: center;
  color: #969696;
  font-weight: 300;
}
.social-title {
  font-weight: 300;
  color: #969696;
  text-align: center;
  font-size: 14px;
}
.sign-in_button {
  background-color: rgb(52, 174, 196);
  text-align: center;
  color: #fff;
  width: 100%;
  line-height: 36px;
  border-radius: 4px;
  font-weight: 600;
}
.sign-in_button:disabled {
  opacity: 0.3;
}
.sign-in-dialog .bottom {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 1rem;
  padding-top: 0;
}
.sign-in-dialog .bottom.flex-center {
  justify-content: center;
}
.sign-in-dialog .bottom button {
  background-color: transparent;
  color: rgb(160, 160, 160);
  transition: color 300ms ease;
  outline: 0;
}
.sign-in-dialog .bottom button:hover {
  color: rgb(77, 75, 75);
}
.sign-in-dialog .bottom .hor-div {
  width: 1px;
  height: 21px;
  background-color: rgb(221, 221, 221);
}
.sign-in-dialog {
  position: relative;
}
.reset-dialog_close-button,
.cancel-appointment-dialog_close-button,
.appointment-list-dialog_close-button,
.profile-dialog_close-button,
.sign-in-dialog_close-button {
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  padding: 0.2rem;
  outline: 0;
  color: rgb(196, 196, 196);
  transition: color 300ms ease;
}
.reset-dialog_close-button:hover,
.cancel-appointment-dialog_close-button:hover,
.appointment-list-dialog_close-button:hover,
.profile-dialog_close-button:hover,
.sign-in-dialog_close-button:hover {
  color: rgb(70, 70, 70);
}
.reset-dialog_wrapper {
  padding: 0.5rem 1rem;
}
.reset-dialog_wrapper,
.appointment-list-dialog_wrapper {
  position: relative;
}
.appointment-list-dialog_wrapper {
  width: 450px;
}
.profile-dialog_wrapper {
  width: 600px;
  display: flex;
  position: relative;
}
.profile-dialog_wrapper .left-side {
  width: 250px;
  background-color: rgb(241, 241, 241);
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.profile-dialog_wrapper .left-side p {
  color: #969696;
  padding: 1rem;
  font-size: 12px;
  font-weight: 300;
}
.profile-dialog_wrapper .right-side {
  flex: auto
}
.cancel-appointment-dialog_wrapper {
  padding: 1rem;
}
.cancel-appointment-dialog_wrapper .bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.cancel-appointment-dialog_wrapper .bottom button {
  padding: 0.5rem 2rem;
  border-radius: 4px;
  margin: 0 0.5rem;
  outline: 0;
}
.cancel-appointment-dialog_wrapper .refuse-button {
  background-color: rgb(240, 240, 240);
  color: #777;
}
.cancel-appointment-dialog_wrapper .accept-button {
  background-color: #ff6a69;
  color: #fff; 
}
.cancel-appointment-dialog_title {
  line-height: 1.2;
}
.reset-dialog_title,
.cancel-appointment-dialog_title,
.appointment-list-dialog_title,
.profile-dialog_title {
  font-weight: 600;
  text-align: center;
  padding: 1rem 0;
  font-size: 1.5rem;
  color: #424242;
}
.profile-dialog_wrapper form {
  padding: 1rem 1.5rem;
}
.profile-dialog_wrapper .right-side .bottom {
  display: flex;
}
.profile-dialog_wrapper .right-side .bottom button:first-child {
  margin-right: 6px;
}
.profile-dialog_wrapper .right-side .bottom button:last-child {
  margin-left: 6px;
}
.landing-button {
  background-color: #5abfda;
  border: 1px solid #5abfda;
  text-align: center;
  color: #fff;
  width: 100%;
  height: 36px;
  border-radius: 4px;
  font-weight: 300;
  outline: 0;
  
}
.outline-landing-button {
  background-color: #fff;
  color: #5abfda;
}
.sex-group {
  margin-bottom: 24px;
}
.custom-field {
  display: block;
  width: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background-color: #f2f2f2;
  outline: none;
  border-radius: 4px;
  padding: 6px;
  padding-left: 12px;
  font-size: 16px;
  transition: box-shadow 300ms ease;
  font-weight: 500;
  color: #06003C;
  height: 36px;
  margin-bottom: 24px;
}
.left-side .bottom {
  margin-top: 1rem;
  padding: 12px;
  display: flex;
  flex-direction: column;
}
.left-side .bottom button {
  padding: 0 12px;
}
.change-password-button {
  height: 36px;
  border-radius: 4px;
  color: #7a7a7a;
  background-color: rgb(230, 230, 230);
  margin-bottom: 12px;
  outline: 0;
}
.change-password-button:hover {
  background-color: rgb(218, 218, 218);
}
.logout-button {
  background-color: #ff6a69;
  height: 36px;
  border-radius: 4px;
  color: #fff;
  outline: 0;
}
.overlay-loading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, .8);
  z-index: 4;
}
.appointment-list {
  padding: 1rem;
  overflow: auto;
  max-height: 70vh;
  min-height: 23rem;
  display: flex;
  flex-direction: column;
}
.appointment-list.center {
  justify-content: center;
}
.appointment-item {
  box-shadow: 0 3px 7px 3px rgba(0, 0, 0, .04);
  margin-bottom: 1rem;
  border-radius: 4px;
}
.appointment-item .top {
  display: flex;
  align-items: center;
  padding: 1rem;
}
.appointment-item .bottom {
  background-color: rgb(250, 250, 250);
  padding: 0.3rem;
}
.appointment-item .bottom button {
  border-radius: 4px;
  font-size: 14px;
  padding: 0.5rem 1rem;
  color: #6d6d6d;
  font-weight: 300;
}
.appointment-item .bottom button:first-child {
  margin-right: 0.5rem;
}
.appointment-item:last-child {
  margin-bottom: 0;
}
.appointment-list-dialog .avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  flex: 0 0 80px;
  border-radius: 50%;
  overflow: hidden;
  background-color: rgba(0,0,0,.05);
  position: relative;
}
.appointment-list-dialog .avatar > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-size: cover;
}
.appointment-list-dialog .avatar .placeholder {
  width: 40px;
}
.appointment-list-dialog .name {
  font-size: 18px;
  font-weight: 300;
  color: #636363;
  margin-left: 12px;
  line-height: 1;
}
.appointment-list-dialog .department {
  color: #a0a0a0;
  font-size: 12px;
  margin-top: 6px;
  margin-left: 12px;
  line-height: 1;
  margin-bottom: 0.2rem;
}
.appointment-list-dialog .type {
  font-size: 12px;
  color: #636363;
  display: flex;
  align-items: center;
  margin: 4px 0;
  margin-left: 12px;
}
.appointment-list-dialog .type i {
  font-size: 18px;
}
.appointment-list-dialog .type span {
  margin-left: 3px;
}
.appointment-list-dialog .time {
  margin-left: 12px;
  color: #424242;
}

.appointment-list-dialog .appointment-time {
  display: flex;
  align-items: center;
  margin-left: 12px;
}
.appointment-list-dialog .appointment-time > div {
  display: flex;
  align-items: center;
}
.appointment-list-dialog .appointment-time i {
  color: #636363;
  margin-right: 0.3rem;
  font-size: 18px;
}
.appointment-list-dialog .appointment-time span {
  color: #424242;
  font-size: 12px;
}
.appointment-list-dialog .cancel-button {
  padding: 0.4rem 0.8rem;
  font-size: 0.8rem;
  border-radius: 4px;
  margin-left: auto;
  color: #696969;
  background-color: #f7f8fc;
  outline: 0;
}
.appointment-list-loading {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
.appointment-list-loading img {
  width: 80px;
}
.appointment-list-loading span {
  color: #c9c9c9;
  font-size: 16px;
  font-weight: 300;
  text-align: center;
}
.appointment-loading .right-side {
  width: 100%;
}
.appointment-loading .date,
.appointment-loading .time,
.appointment-loading .department,
.appointment-loading .name,
.appointment-loading .avatar,
.appointment-loading .button {
  animation: pulse 1.3s infinite ease-in-out;
}
.appointment-loading .name {
  width: 80%;
  height: 18px;
}
.appointment-loading .department {
  width: 70%;
  height: 12px;
}
.appointment-loading .date {
  width: 30%;
  height: 18px;
}
.appointment-loading .time {
  width: 20%;
  height: 18px;
}
.appointment-loading .button {
  width: 25%;
  height: 37px;
}
@keyframes pulse {
  0% {
    background-color: rgba(0, 0, 0, 0.05);
  }
  50% {
    background-color: rgba(0, 0, 0, 0.1);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
@media (max-width: 1200px) {
  .map {
    left: 50%;
  }
  .address-box {
    width: 50%;
  }
}
@media (max-width: 960px) {
  .map {
    left: 60%;
  }
  .address-box {
    width: 60%;
  }
}
@media (max-width: 800px) {
  section.main {
    height: 23rem;
  }
  section.main .content h1 {
    font-size: 3rem;
  }
  section.main .content p {
    font-size: 1.2rem;
  }
}
@media (max-width: 750px) {
  .map-section {
    flex-direction: column;
  }
  .map {
    position: static;
    height: 180px;
    width: 100%;
  }
  .address-box {
    width: 100%;
  }
}
@media (max-width: 600px) {
  .appointment-landing {
    width: 100%;
    padding: 0 24px;
  }
  .profile-dialog_wrapper {
    width: 100%;
    flex-direction: column;
  }
  .profile-dialog_wrapper .left-side {
    width: 350px;
    flex-direction: row;
    padding: 1rem;
    padding-top: 2rem;
  }
  .profile-dialog_wrapper .left-side p {
    display: none;
  }
  .left-side .bottom {
    margin-top: 0;
    padding: 0;
    padding-left: 2rem;
  }
  .profile-dialog_title {
    display: none;
  }
  .sex-group,
  .profile-dialog_wrapper >>> .vm-form-field {
    margin-bottom: 1rem;
  }
  .profile-dialog_wrapper >>> .logo {
    width: 100px;
    height: 100px;
    margin: 0;
  }
  .profile-dialog_wrapper >>> .remove-button-wrap {
    top: 3px;
    left: 3px;
  }
}
@media (max-width: 540px) {
  h3 {
    font-size: 23px;
  }
  section.main {
    height: 20rem;
  }
  section.main .content h1 {
    font-size: 2rem;
  }
  section.main .content p {
    font-size: 1rem;
  }
  section.main .content {
    padding: 0 1rem;
  }
  .services .service {
    min-width: 10rem;
    height: 6rem;
    font-size: 13px;
    padding: 0;
  }
}
@media (max-width: 480px) {
  .appointment-list-dialog_wrapper {
    width: 350px;
  }
}

.link {
  color: #777;
  text-decoration: none;
  margin-top: 0.5rem;
  border-radius: 4px;
  line-height: 36px;
}
.link:hover {
  color: #777;
  background-color: rgba(0,0,0,.05);
}
</style>
